package com.vamvisions.main.contact.data.mapper

import com.vamvisions.main.api.contact.ContactTopicDto
import com.vamvisions.main.contact.domain.model.ContactTopic

fun ContactTopic.toDto() = when (this) {
    ContactTopic.APP_DEVELOPMENT -> ContactTopicDto.APP_DEVELOPMENT
    ContactTopic.DIGITAL_PRODUCT -> ContactTopicDto.DIGITAL_PRODUCT
    ContactTopic.PARTNERSHIP -> ContactTopicDto.PARTNERSHIP
    ContactTopic.OTHER -> ContactTopicDto.OTHER
}
